// extracted by mini-css-extract-plugin
export default {"groupAddress":"address_groupAddress__bfru9","actions":"address_actions__95y5G","data":"address_data__2wGhD"};